import { render, staticRenderFns } from "./ParticipantsList.vue?vue&type=template&id=66c897ec"
import script from "./ParticipantsList.vue?vue&type=script&lang=js"
export * from "./ParticipantsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports